import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { ActionStatusPill } from '@components/ActionStatusPill';
import { ActionPillVariant } from '@components/ActionStatusPill/enums';
import { StatusIcon } from '@components/StatusIcon';
import { StatusIconType } from '@components/StatusIcon/enums';

const StyledCard = styled(Card)({
  borderRadius: 2,
  height: '100%',
});

interface IStatus {
  icon?: React.ReactNode;
  label: string;
  type: StatusIconType;
}

interface IStatusCard {
  description: string;
  pillLabel: string;
  pillVariant: ActionPillVariant;
  statuses: IStatus[];
  title: string;
}

export const StatusCard = ({
  description,
  pillLabel,
  pillVariant,
  statuses,
  title,
}: IStatusCard) => {
  return (
    <StyledCard variant="outlined">
      <CardContent>
        <Grid
          alignItems="start"
          container={true}
          justifyContent="space-between"
        >
          <Grid item={true}>
            <Typography fontWeight="bold" variant="subtitle1">
              {title}
            </Typography>
          </Grid>
          <Grid item={true}>
            <ActionStatusPill
              label={pillLabel}
              small={true}
              variant={pillVariant}
            />
          </Grid>
        </Grid>
        <Typography color="text.secondary" mb={2} mt={1} variant="body2">
          {description}
        </Typography>
        <Box display="flex" flexDirection="column" gap={1}>
          {statuses.map((status, index) => (
            <Box
              alignItems="center"
              display="flex"
              gap={1}
              justifyContent="space-between"
              key={`${status.label}_${index}`}
            >
              <Box alignItems="center" display="flex" gap={1}>
                <Typography color="#666" variant="body2">
                  {status.icon}
                </Typography>
                <Typography color="#333" variant="body2">
                  {status.label}
                </Typography>
              </Box>
              <StatusIcon type={status.type} />
            </Box>
          ))}
        </Box>
      </CardContent>
    </StyledCard>
  );
};
